import SanityBlockContent from "@sanity/block-content-to-react";
import React, { useEffect, useState } from "react";
import { useLayoutEffect } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

import { Link, useParams } from "react-router-dom";
import { sanityClient, urlFor } from "../client";

import { useGlobalContext } from "../Context";
import { color } from "../Components/Utils/Color";

export default function SinglePost() {
  const { slug } = useParams();
  const [post, setPost] = useState([]);
  const [loading, setLoading] = useState(true);

  const { setNav } = useGlobalContext();

  useLayoutEffect(() => {
    setNav(false);
    document.title = `Beyond Limits Football Academy - ${slug}`;
  }, [slug, setNav]);

  useEffect(() => {
    sanityClient
      .fetch(
        `*[slug.current == "${slug}"][0]{
      title,
      slug{
         current
       }   ,
         mainImage{
         asset->{
           _id,
           url,
           alt
         }
         }
       ,
         publishedAt,
         body,
         _id,
         description,
         author ->,
         categories[] ->
    }
    `
      )
      .then((data) => {
        setLoading(true);
        setPost(data);
        setLoading(false);
      })
      .catch((error) => console.log(error));
  }, [slug]);

  const { mainImage, publishedAt, body, author, title } = post;

  if (loading) {
    return (
      <section style={{ height: "700px" }}>
        <div className="container">
          <p
            style={{
              fontSize: "5rem",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            Loading....
          </p>
        </div>
      </section>
    );
  }
  // console.log(post);

  return (
    <section className="Blog__Section">
      <div className="container">
        <Link to={"/blog"} className="flex items-center gap-[10px] no-underline">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            fill={color.primary}
            class="bi bi-arrow-left"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
            />
          </svg>
          <span
            className={`text-[${color.primary}]  text-[20px] uppercase font-semibold`}
          >
            all blogs
          </span>
        </Link>
        {title && (
          <p
            title={title}
            className="text-[#007cba] !my-[10px] text-[2.5rem] sm:text-[2rem] font-semibold capitalize  group-hover:text-gray-600"
          >
            {title}
          </p>
        )}
        {mainImage && mainImage.asset && (
          <LazyLoadImage
            alt={slug}
            effect="blur"
            src={urlFor(mainImage.asset).url()}
            className="Blog__Image--url h-[200px] ms:!h-[300px] "
          />
        )}
        {/* {publishedAt && (
          <span className="Blog__date">
            {new Date(publishedAt).toLocaleDateString("en-US", {
              dateStyle: "full",
            })}
          </span>
        )} */}
        {author && (
          <span className="Blog__Author flex items-center gap-[10px]">
            <img
              src={urlFor(author.image).url()}
              style={{
                width: "3rem",
                height: "3rem",
                verticalAlign: "bottom",
              }}
              alt={author.name}
            />

            {author.name}
          </span>
        )}
        <div className="Blog__Content">
          <SanityBlockContent
            blocks={body}
            projectId="qhw5zlf9"
            dataset="production"
          />
        </div>
      </div>
    </section>
  );
}
